import React from 'react';
import ButtonsGeneric from '../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../components/NovoSistema/ContainerSection';
import DoubleInput from '../../../../../../../components/NovoSistema/DoubleInput';
import InputText from '../../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function DemonstDeResultDoProj() {
  return (
    <div>
      <ContainerSection>
        <WrapperInputsNewSystem>
          <InputText title="Receita Bruta Total" id="ReceitaBrutaTotal" disabled={true} widthPercentage="45%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Custos Variáveis" id="CustosVariaveis" disabled={true} widthPercentage="45%" />
          <InputText title="Gastos Diretos com o Projeto" id="GastosDiretosComOProjeto" widthPercentage="45%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Despesas Variáveis" id="DespesasVariaveis" disabled={true} widthPercentage="45%" />
          <SelectAndOptions
            title="Gastos com Prospecção e Comissão"
            id="GastosComProspeccaoEComissao"
            optionsArray={[
              '0,0',
              '0,5',
              '1,0',
              '1,5',
              '2,0',
              '2,5',
              '3,0',
              '3,5',
              '4,0',
              '4,5',
              '5,0',
              '5,5',
              '6,0',
              '6,5',
              '7,0',
              '10,0',
              '12,0',
            ]}
            widthPercentage="45%"
          />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText
            title="Total dos Gastos Variáveis"
            id="TotalDosGastosVariaveis"
            disabled={true}
            widthPercentage="45%"
          />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <DoubleInput title="Margem de Contribuição" id="MargemDeContribuicao" disabled={true} widthPercentage="50%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText
            title="Despesas Reconhecidas como Perdas"
            id="DespesasReconhecidasComoPerdas"
            disabled={true}
            widthPercentage="45%"
          />
          <label>Apetite dos RISCOS assumidos</label>
          <SelectAndOptions
            title=""
            id="ApetiteDosRiscosAssumidos"
            optionsArray={['0', '5', '10', '15', '20', '25']}
            widthPercentage="5%"
          />
          <label> % da receita líquida total</label>
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText
            title="Despesas Administrativas"
            id="DespesasAdministrativas"
            disabled={true}
            widthPercentage="45%"
          />
          <label>Gastos fixos com estrutura ADM.</label>
          <SelectAndOptions
            title=""
            id="ApetiteDosRiscosAssumidos"
            optionsArray={['0', '5', '10', '15', '20', '25']}
            widthPercentage="5%"
          />
          <label> % da receita líquida total</label>
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Despesas Comerciais" id="DespesasComerciais" disabled={true} widthPercentage="45%" />
          <label>Gastos fixos com estrutura CML.</label>
          <SelectAndOptions
            title=""
            id="ApetiteDosRiscosAssumidos"
            optionsArray={['0', '5', '10', '15', '20', '25']}
            widthPercentage="5%"
          />
          <label> % da receita líquida total</label>
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Total das Despesas" id="TotalDasDespesas" disabled={true} widthPercentage="45%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <DoubleInput
            title="EBITDA arbitrado do projeto"
            id="EBITDAarbitradoDoProjeto"
            disabled={true}
            widthPercentage="50%"
          />
          <label>Poder de geração de caixa específico deste projeto</label>
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Juros" id="Juros" disabled={true} widthPercentage="45%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Imposto" id="Imposto" disabled={true} widthPercentage="45%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Depreciação" id="Depreciacao" disabled={true} widthPercentage="45%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Amortização" id="Amortizacao" disabled={true} widthPercentage="45%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <DoubleInput title="Resultado Líquido" id="ResultadoLiquido" disabled={true} widthPercentage="50%" />
          <label>Índice de lucratividade</label>
        </WrapperInputsNewSystem>
      </ContainerSection>
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error">Retornar</button>
      </ButtonsGeneric>
    </div>
  );
}
